export function encodeItemId(siteMediaToken, id) {
  return JSON.stringify({
    siteMediaToken,
    id
  });
}
export function decodeItemId(itemId) {
  return JSON.parse(itemId);
}